import React from 'react';
import './app.footer.scss';

function AppFooter() {
    
    return (
        <footer>
            <div className="container">
                <div className="row foot">
                    <div className="col">
                        <div><img src="./logo_c.svg" width="20"/></div>
                        <div className="social">
                            <a target="_blank" href="https://www.facebook.com/profile" data="facebook"><img src='./facebook.svg' width="15"/></a>
                            <a target="_blank" data="youtube"><img src='./instagram.png' width="15"/></a>
                        </div>
                    </div>
                    <div className="col">
                        <h4>Contact us</h4>
                        <div className="cont">
                            <p><a href="https://wa.me/+919891330157?text=I'm interested in your IT services for Laptop Repair">+91 98913 30157</a></p>
                            <p><a href='mailto:compact10itsolutoan@gmail.com'>compact10itsolutoan@gmail.com</a></p>
                            <p><a>B-69, near DDA MARKET, Katwaria Sarai, New Delhi, Delhi 110016</a></p>
                        </div>
                    </div>
                    <div className="col">
                        <h4>Services</h4>
                        <div className="cont">
                            <div><a href='/services#services-1'>Computing</a></div>
                            <div><a href='/services#services-2'>Networking</a></div>
                            <div><a href='/services#services-3'>Security</a></div>
                            <div><a href='/services#services-4'>Data Center</a></div>
                        </div>
                    </div>
                    <div className="col">
                        <h4>About us</h4>
                        <div className="cont">
                            <div><a href="/about">About us</a></div>
                            <div><a href="/contact">Contact us</a></div>
                        </div>
                    </div>
                </div>
                <div className="row copyright">
                
                    <span>Copyright © 2023 COMPACT IT SOLUTIONS. All Right Reserved.</span>
                </div>
            </div>
        </footer>
    )
}

export default AppFooter;
